import { TableColumnMeta } from "ds/components/Table/types";

export const POLICY_TEMPLATES_TABLE_STORAGE_KEY = "policyTemplatesTable";

export enum POLICY_TEMPLATES_COLUMN_ID {
  NAME = "NAME",
  LABELS = "LABELS",
  DESCRIPTION = "DESCRIPTION",
  TYPES = "TYPES",
  IMPORT = "IMPORT",
}

const MAX_CELL_WIDTH = 1200;

export const POLICY_TEMPLATES_TABLE_COLUMNS_CONFIG: Record<
  POLICY_TEMPLATES_COLUMN_ID,
  TableColumnMeta
> = {
  [POLICY_TEMPLATES_COLUMN_ID.NAME]: {
    id: POLICY_TEMPLATES_COLUMN_ID.NAME,
    title: "Name",
    minWidth: 150,
    defaultWidth: 250,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: true,
    canHide: false,
    configurable: true,
  },
  [POLICY_TEMPLATES_COLUMN_ID.LABELS]: {
    id: POLICY_TEMPLATES_COLUMN_ID.LABELS,
    title: "Labels",
    minWidth: 100,
    defaultWidth: 200,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: false,
    canHide: true,
    configurable: true,
  },
  [POLICY_TEMPLATES_COLUMN_ID.DESCRIPTION]: {
    id: POLICY_TEMPLATES_COLUMN_ID.DESCRIPTION,
    title: "Description",
    minWidth: 120,
    defaultWidth: 200,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: false,
    canHide: true,
    configurable: true,
  },
  [POLICY_TEMPLATES_COLUMN_ID.TYPES]: {
    id: POLICY_TEMPLATES_COLUMN_ID.TYPES,
    title: "Type",
    minWidth: 80,
    defaultWidth: 120,
    maxWidth: 200,
    resizable: false,
    allowsSorting: true,
    canHide: true,
    configurable: true,
  },
  [POLICY_TEMPLATES_COLUMN_ID.IMPORT]: {
    id: POLICY_TEMPLATES_COLUMN_ID.IMPORT,
    title: "Actions",
    noHeader: true,
    minWidth: 80,
    defaultWidth: 80,
    maxWidth: 80,
    resizable: false,
    allowsSorting: false,
    canHide: false,
    configurable: false,
  },
};

export const POLICY_TEMPLATES_SORT_CONFIG: Partial<Record<POLICY_TEMPLATES_COLUMN_ID, string>> = {
  [POLICY_TEMPLATES_COLUMN_ID.NAME]: "name",
  [POLICY_TEMPLATES_COLUMN_ID.TYPES]: "type",
};
